module.exports = __webpack_public_path__ + "assets/d1f5cf1533eb4e425ec69ad21339cba1.jpg";